// src/features/riskmize/riskmize.api.js
// Thin wrapper around the shared `request()` client in src/lib/trackizy.js.
//
// Contract notes (see src/lib/trackizy.js `request`):
//   - Paths are relative and DO NOT include the leading `/api` — the client
//     prefixes it internally (`fetch('/api' + path)`).
//   - The second arg is a fetch-init-like shape: `{ method, headers, body }`.
//   - `body` must be pre-stringified; the client auto-sets Content-Type when
//     body is present, so we JSON.stringify at the call site.
import { request } from '../../lib/trackizy.js';

export const riskmizeApi = {
  listIncidents({ bbox, from, to, severity, category } = {}) {
    const qs = new URLSearchParams();
    if (bbox && bbox.length === 4) qs.set('bbox', bbox.join(','));
    if (from) qs.set('from', from.toISOString());
    if (to) qs.set('to', to.toISOString());
    if (severity?.length) qs.set('severity', severity.join(','));
    if (category?.length) qs.set('category', category.join(','));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return request(`/riskmize/incidents${suffix}`);
  },
  getIncident(id) {
    return request(`/riskmize/incidents/${id}`);
  },
  listCategories() {
    return request('/riskmize/categories');
  },
  getSettings() {
    return request('/riskmize/settings');
  },
  updateSettings(patch) {
    return request('/riskmize/settings', {
      method: 'PATCH',
      body: JSON.stringify(patch),
    });
  },
};
